import React from 'react';
import styles from '../NeedInfoV2.module.scss';

interface EmailVariable {
    key: string;
    value: string;
}

interface EmailTemplateProps {
    subject: string;
    body: string;
    variables: EmailVariable[];
}

const EmailPreview: React.FC<EmailTemplateProps> = ({ subject, body, variables }) => {
    // Replace variables in the template with their values
    const processTemplate = (template: string): string => {
        let processedTemplate = template;

        variables.forEach((variable) => {
            const regex = new RegExp(`{{${variable.key}}}`, 'g');
            processedTemplate = processedTemplate.replace(regex, variable.value);
        });

        return processedTemplate;
    };

    const processedSubject = processTemplate(subject);
    const processedBody = processTemplate(body);

    return (
        <div className={styles.EmailPreview}>
            <div className={styles.EmailPreviewHeader}>
                <h3>Email Preview</h3>
            </div>
            <div className={styles.EmailPreviewContent}>
                <div className={styles.EmailPreviewSubject}>
                    <strong>Subject:</strong> {processedSubject}
                </div>
                <div className={styles.EmailContainer}>
                    <div className={styles.EmailPreviewBody} dangerouslySetInnerHTML={{ __html: processedBody }} />
                </div>
            </div>
        </div>
    );
};

export default EmailPreview;
